import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  AveragePlayerScore,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useDefaultAverageScore } from '@sorare/core/src/hooks/useDefaultAverageScore.ts';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

import { BreakdownHelper } from './BreakdownHelper/index.tsx';
import { BreakdownLabel } from './BreakdownLabel/index.tsx';

const Title = styled(Horizontal)`
  align-items: baseline;
`;

const L15_BREAKDOWNS = [
  AveragePlayerScore.LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE,
  AveragePlayerScore.LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE,
];

const L10_BREAKDOWNS = [
  AveragePlayerScore.LAST_TEN_PLAYED_AVERAGE_ALL_AROUND_SCORE,
  AveragePlayerScore.LAST_TEN_PLAYED_AVERAGE_DECISIVE_SCORE,
];

export const Breakdown = () => {
  const defaultAverageScore = useDefaultAverageScore();
  const { sport } = useSportContext();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();

  const breakdown = statsManager[PlayerSearchViewAttributes.BREAKDOWN];

  const breakdowns =
    defaultAverageScore === AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE
      ? L10_BREAKDOWNS
      : L15_BREAKDOWNS;
  if (sport !== Sport.FOOTBALL) return null;
  return (
    <Vertical>
      <Title>
        <LabelM color="var(--c-nd-600)">
          <FormattedMessage
            defaultMessage="Breakdown (L10)"
            id="searchCommonPlayer.statsManager.breakdown.title2"
          />
        </LabelM>
        <Tooltip title={<BreakdownHelper />}>
          <FontAwesomeIcon
            color="var(--c-nd-600)"
            icon={faInfoCircle}
            size="xs"
          />
        </Tooltip>
      </Title>
      {breakdowns.map(score => (
        <Switch
          key={score}
          checked={breakdown.includes(score)}
          onChange={() =>
            updatePlayerSearchViewAttribute(
              PlayerSearchViewAttributes.BREAKDOWN,
              breakdown.includes(score)
                ? breakdown.filter(s => s !== score)
                : [...breakdown, score]
            )
          }
          label={<BreakdownLabel score={score} />}
        />
      ))}
    </Vertical>
  );
};
